import { EventEmitter } from '@angular/core';
import {
  FormStateChangeService,
  StateInputFields,
  FormStateChange
} from './form-state-change.service';

export default abstract class AbstractFormStateService {
  protected abstract outputState: any;
  protected abstract inputState: any;
  protected abstract observedFields: StateInputFields[];
  protected emitter: EventEmitter<any> = new EventEmitter();

  constructor(protected formStateChangeService: FormStateChangeService) {}

  protected subscribeToFormService() {
    this.formStateChangeService.subscribe((stateChange: FormStateChange) => {

      if (this.observedFields.indexOf(stateChange.inputField) + 1) {
        this.handleStateChange(stateChange);
      }
    });
  }

  protected emit() {
    this.emitter.emit(this.outputState);
  }

  protected abstract handleStateChange(stateChange: FormStateChange);

  public subscribe(callback: any) {
    return this.emitter.subscribe(callback);
  }
}
